import {
    handleAvailable,
    handleRequest,
    handleUnavailable,
} from '../reducerHandlers';
import { createReducer } from './utils';
import {
    SCOPES_SUGGESTIONS_REQUEST,
    SCOPES_SUGGESTIONS_AVAILABLE,
    SCOPES_SUGGESTIONS_UNAVAILABLE,
    SNACK_SET,
} from './constants';

const defaultState = {
    scopesSuggestions: [],
    isScopesSuggestionsLoading: false,
};

export const reducer = createReducer(defaultState, {
    [SCOPES_SUGGESTIONS_REQUEST]: handleRequest,
    [SCOPES_SUGGESTIONS_AVAILABLE]: handleAvailable,
    [SCOPES_SUGGESTIONS_UNAVAILABLE]: handleUnavailable,
});

export function getScopesSuggestions(projectUrl, projectName, project_id) {
    return async (dispatch, _, { services: { dataSource } }) => {
        const keyState = 'scopesSuggestions';
        const loadingName = 'isScopesSuggestionsLoading';

        dispatch({
            type: SCOPES_SUGGESTIONS_REQUEST,
            payload: { loadingName },
            additionalStates: {
                [keyState]: []
            }
        });

        try {
            const response = await dataSource.getScopesSuggestions(
                projectUrl,
                projectName,
                project_id
            );

            let data = [];
            if (Array.isArray(response)) {
                data = response;
            } else if (response && typeof response === 'object') {
                data = response.suggestions || response.scopes || response.data || [];
            } else if (typeof response === 'string') {
                try {
                    const parsed = JSON.parse(response);
                    if (Array.isArray(parsed)) {
                        data = parsed;
                    } else if (parsed && typeof parsed === 'object') {
                        data = parsed.suggestions || parsed.scopes || parsed.data || [];
                    }
                } catch (e) {
                    console.warn('Failed to parse scopes suggestions response', e);
                }
            }
            const isEmptySuggestions = !data || data.length === 0 ||
                (Array.isArray(data) && data.every(item => Array.isArray(item) && item.length === 0));

            dispatch({
                type: SCOPES_SUGGESTIONS_AVAILABLE,
                payload: {
                    keyState,
                    data: data,
                    loadingName,
                },
            });

            // If there are no suggestions, show a snack to inform there are no new scope suggestions
            if (isEmptySuggestions) {
                dispatch({
                    type: SNACK_SET,
                    payload: {
                        snack: {
                            open: true,
                            message: 'No new scope suggestions available.',
                            severity: 'warning',
                            isAiResult: true,
                        },
                    },
                });
            }
        } catch (error) {
            console.error('Error fetching scopes suggestions:', error);
            dispatch({
                type: SCOPES_SUGGESTIONS_UNAVAILABLE,
                payload: {
                    keyState,
                    loadingName,
                    defaultState: [],
                },
            });

            dispatch({
                type: SNACK_SET,
                payload: {
                    snack: {
                        open: true,
                        message: 'Error generating AI suggestions. Please try again.',
                        severity: 'error',
                    },
                },
            });
        }
    };
}

export function saveSuggestedScopes(payload) {
    return async (dispatch, _, { services: { dataSource } }) => {
        const loadingName = 'isScopesSuggestionsLoading';
        dispatch({
            type: SCOPES_SUGGESTIONS_REQUEST,
            payload: { loadingName },
        });

        try {
            const response = await dataSource.saveSuggestedScopes(payload);
            dispatch({
                type: SCOPES_SUGGESTIONS_AVAILABLE,
                payload: {
                    keyState: 'scopesSuggestions',
                    data: [],
                    loadingName,
                }
            });

            dispatch({
                type: SNACK_SET,
                payload: {
                    snack: {
                        open: true,
                        message: response.message,
                        severity: response.status_type,
                    },
                },
            });

            return response;
        } catch (error) {

            dispatch({
                type: SCOPES_SUGGESTIONS_UNAVAILABLE,
                payload: { loadingName, error },
            });

            const backendError = error.response?.data;
            const message = backendError?.message || 'Error saving suggested scopes.';
            const severity = backendError?.status_type || 'error';

            dispatch({
                type: SNACK_SET,
                payload: {
                    snack: {
                        open: true,
                        message: message,
                        severity: severity,
                    },
                },
            });
            throw error;
        }
    };
}